// @ts-nocheck
import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(customerAddressFormFieldStyles, {
    firstNameGridItem: { width: [12, 6, 6, 6, 6] },
    lastNameGridItem: { width: [12, 6, 6, 6, 6] },
    companyNameGridItem: { width: [12, 6, 6, 6, 6] },
    attentionGridItem: { width: [12, 6, 6, 6, 6] },
    address1GridItem: { width: 12 },
    address2GridItem: { width: 12 },
    address3GridItem: { width: 12 },
    address4GridItem: { width: 12 },
    countryGridItem: { width: 12 },
    cityGridItem: { width: 12 },
    stateGridItem: { width: [12, 6, 6, 6, 6] },
    postalCodeGridItem: { width: [12, 6, 6, 6, 6] },
    phoneGridItem: { width: [12, 6, 6, 6, 6] },
    faxGridItem: { width: [12, 6, 6, 6, 6] },
    emailGridItem: { width: 12 },
});
